import React from 'react';
import s from './BaseComp.scss';

interface Props {
    index: number
}

export const TextCompLoading = (props: Props) => {
    const { index } = props;
    const width = index % 2 ? '80%' : '100%';
    return (
        <div className={s.textCompLoadingBox} style={{ width }}>
            <div className={s.textCompLoading} />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/BaseComp/TextFeedItem.loading.tsx